var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',{attrs:{"allow-empty":false,"options":_vm.options,"value":_vm.selected,"disabled":_vm.disabled,"track-by":"unit","label":"label"},on:{"select":_vm.select}})
}
var staticRenderFns = []

export { render, staticRenderFns }